import { FormControl, FormHelperText, Typography } from '@mui/material';
import { FormInputProps } from 'interfaces/input';
import { ReactNode, useEffect } from 'react';
import { FieldError, useController } from 'react-hook-form';

interface BaseFormProps extends FormInputProps {
    children?: ReactNode;
    onError?: (error: FieldError | undefined) => void;
    required?: boolean;
}

export const BaseForm = ({ name, control, children, onError, required, label }: BaseFormProps) => {
    const { fieldState } = useController({ name, control });
    const { error } = fieldState;
    useEffect(() => {
        onError && onError(error);
    }, [error]);

    return (
        <FormControl fullWidth>
            <Typography variant="caption" sx={{ paddingTop: '0', marginTop: '0' }}>
                {label}
                {required && <span style={{ color: 'red' }}> *</span>}
            </Typography>
            {children}
            {Boolean(error) && <FormHelperText sx={{ color: 'red', mx: 0 }}>{error?.message}</FormHelperText>}
        </FormControl>
    );
};
